import { render, staticRenderFns } from "./BlindOrder.vue?vue&type=template&id=15e676ec&scoped=true"
import script from "./BlindOrder.vue?vue&type=script&lang=js"
export * from "./BlindOrder.vue?vue&type=script&lang=js"
import style0 from "./BlindOrder.vue?vue&type=style&index=0&id=15e676ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e676ec",
  null
  
)

export default component.exports